module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-080f375f2d5ad154ac28758e9d7d8031.graphql";